import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class EntitlementService {
    private entitlementsReadySubject = new BehaviorSubject<boolean>(false);
    public entitlementsReady$ = this.entitlementsReadySubject.asObservable();

    private _entitlements: Record<string, boolean> = {
        enableMediaConnect: false,
        enableOutreachMediaConnect: false,
        enableContactsMediaConnect: false,
        enableGlobalSearch: false,
        enableAnalyticsContentManager: false,
        enableSubscriberContentManager: false,
        enableDataMigrationContentManager: false,
        enableApprovedSenderOutreach: false,
        enablePressroom: true,
    };

    setEntitlements(ent: Record<string, boolean>) {
        this._entitlements = { ...ent };
        this.entitlementsReadySubject.next(true);
    }

    get entitlements(): Readonly<Record<string, boolean>> {
        return this._entitlements;
    }

    getEntitlement(key: string): boolean {
        return !!this._entitlements[key];
    }
}
